<template>
  <div class="hello">
    <div class="dibu">
      <div>
        <div style="font-size: .7vw;line-height: .8vw;letter-spacing: 1px;font-weight: 700;margin-bottom: 2.08vw;">联系我们
        </div>
        <div class="dibu-left" style="font-size: .7vw;line-height: .8vw;letter-spacing: 1px;margin-bottom: 2.08vw;">
          <div style="color:#464748;">
            <div style="margin-bottom: 1vw;">商务合作 <span style="margin: 0 10px;">3049401406@qq.com</span></div>
            <div>加入我们 <span style="margin: 0 10px;">3049401406@qq.com</span> </div>
          </div>
          <div style="color:#464748;padding-left: 7vw;">
            <div style="margin-bottom: 1vw;">联系电话 <span>400-805-3118</span></div>
            <div>公司地址 <span>深圳市罗湖区宝安路与解放路交汇处振业大厦A座20楼</span> </div>
          </div>
        </div>
      </div>
      <div class="dibu-right">
        <div class="dibu-right-text">关注我们</div>
        <div class="lxfs">
          <!-- <div class="iconfont icon-weibo"></div> -->
          <div class="iconfont icon-weixin icon-position"></div>
          <div class="iconfont icon-douyin icon-position"></div>
          <div class="iconfont icon-xiaohongshu1 icon-position"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.lxfs{
	display: flex;
	flex-direction: row;
}
.dibu {
  /* padding-top:3vw; */
  background-color: #ebeef1;
  display: flex;
  justify-content: space-between;
  padding: 1.5vw 15vw;
  border-bottom: 2px solid #d3d6d8;
}

.icon-position{
	margin-left: 20px;
}

.dibu-left {
  display: flex;
  justify-content: space-between;
}

.dibu-right-text {
  font-size: .7vw;
  line-height: .8vw;
  font-weight: 700;
  margin-bottom: 2.08vw;
  margin-right: 7vw;
}
</style>
